export const LOADING_EMPLOYEE_MONITOR = "LOADING_EMPLOYEE_MONITOR";
export const SAVE_LOADING_EMPLOYEE_MONITOR = "SAVE_LOADING_EMPLOYEE_MONITOR";
export const GET_EMPLOYEE_MONITOR = "GET_EMPLOYEE_MONITOR";
export const FORM_FAIL = "FORM_FAIL";
export const EMPLOYEE_MONITOR_FAIL = "EMPLOYEE_MONITOR_FAIL";
export const LOADING_EMPLOYEE_MONITOR_BY_ID = "LOADING_EMPLOYEE_MONITOR_BY_ID";
export const GET_EMPLOYEE_MONITOR_BY_ID = "GET_EMPLOYEE_MONITOR_BY_ID";

